import DOMPurify from 'dompurify';

/**
 * FAQ HTML sanitizer (C3, layer 1 — authoritative, render-side).
 *
 * FAQ content comes from api.trade.vision and is rendered via `dangerouslySetInnerHTML`. DOMPurify
 * strips scripts, event handlers and `javascript:`/data URLs while keeping safe formatting, so any
 * XSS is neutralized even if the stored HTML is dirty. Keep this allow-list in sync with the backend
 * `sanitizeFaqContent`.
 */
const FAQ_ALLOWED_TAGS = ['p', 'br', 'ul', 'ol', 'li', 'strong', 'b', 'em', 'i', 'u', 'h2', 'h3', 'h4', 'span', 'a'];

// Harden anchors: force rel on links that carry an href (parity with the backend sanitizer).
DOMPurify.addHook('afterSanitizeAttributes', (node) => {
  if (node.tagName === 'A' && node.getAttribute('href')) {
    node.setAttribute('rel', 'noopener noreferrer');
  }
});

export const sanitizeFaqHtml = (html?: string): string =>
  DOMPurify.sanitize(html ?? '', {
    ALLOWED_TAGS: FAQ_ALLOWED_TAGS,
    ALLOWED_ATTR: ['href', 'target', 'rel', 'style'],
    ALLOWED_URI_REGEXP: /^(?:https?:|mailto:)/i,
  });
